<script setup>
const props = defineProps({
  id: String,
  value: Number,
  name: String,
  label: String,
  required: {
    type: Boolean,
    default: false
  }
})
const emit = defineEmits(['onChanged'])
const state = ref('')
const handleChange = (event) => {
  if (!event.target.checked && props.required) {
    state.value = 'invalid';    
  }
  else {
    state.value = 'valid';
  }

  emit('onChanged', {
    id: props.id,
    name: props.name,
    value: event.target.value,
    checked: event.target.checked,
    valid: state.value === 'valid'
  })
}
</script>
<template>
  <div class="form-check ">
    <input class="form-check-input" type="checkbox" :value="value" :id="id" :name="name" @change="handleChange">
    <label class="form-check-label" :for="id">
      {{ label }}
    </label>
  </div>
</template>

<style lang="scss" scoped>

  .form-check {
    margin-left: -3px;
    .form-check-label {
      padding-left: 5px;
    }
  }

</style>